import React from 'react'

import { Markdown } from 'ui/components'

// eslint-disable-next-line import/no-unresolved, import/no-webpack-loader-syntax
import text from '!!raw-loader!./text.md'

export default function () {
  return (
    <Markdown>
      {text}
    </Markdown>
  )
}
